import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-复制",
  "use": "icon-复制-usage",
  "viewBox": "0 0 96 96",
  "content": "<symbol viewBox=\"0 0 96 96\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-复制\">\n    <title>icon/10pt/复制</title>\n    <g id=\"icon-复制_icon/10pt/复制\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <polyline id=\"icon-复制_路径\" stroke=\"#2C2C2E\" stroke-width=\"10\" stroke-linecap=\"round\" points=\"27.1578947 26.0809263 27.1578947 12 84 12 84 68.8421053 69.8203579 68.8421053\" />\n        <polygon id=\"icon-复制_路径\" stroke=\"#2C2C2E\" stroke-width=\"10\" fill-rule=\"nonzero\" points=\"12 27.1578947 12 84 68.8421053 84 68.8421053 27.1578947\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/复制.svg
// module id = uCF6
// module chunks = 2